import { Hash } from 'lucide-react'
import { ItemWrapper } from '../../ItemWrapper'

type TagResultProps = {
  tag: string
  onItemClick?: (tag: string) => void
  searchQuery?: string
  groupName?: string
}

export const TagResult = ({
  tag,
  onItemClick,
  searchQuery,
  groupName,
}: TagResultProps) => {
  const handleClick = () => {
    onItemClick?.(tag)
  }

  return (
    <ItemWrapper
      onClick={handleClick}
      searchQuery={searchQuery}
      className="max-w-full gap-none"
      url="/search"
      queryParams={{
        groupName: groupName,
        filter: 'posts',
        q: `#${tag}`,
      }}
    >
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-100">
        <Hash size={20} className="text-gray-500" />
      </div>
      <span className="truncate text-base font-semibold text-gray-900">
        {tag}
      </span>
    </ItemWrapper>
  )
}
